import axios from "axios";
import { ProductPaginated } from "../models/product-paginated.model";
import { Filters } from "../../../../../models/filters.model";

export const getProductsSearchModel = (pageNumber: number, pageSize: number, filters: Filters): any => {
    return axios.get<ProductPaginated>("products/search?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&pickupPointId=" + filters.pickupPointId + "&productName=" + filters.productName + "&categoryId=" + filters.categoryId + "&sortBy=" + filters.sortBy);
}